import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { Button, Grid, IconButton } from "@mui/material";
import { faCaretLeft, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface Props {
  value: number;
  onChange: (value: number) => void;
}

const YearPicker = ({ value, onChange }: Props) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();

  const getCurrentLanguage = (): string => (i18n.language === "en" ? "enGB" : i18n.language);

  const CustomInput = forwardRef(
    (
      {
        id,
        value,
        onClick,
      }: { id: string; value: string; onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void },
      _ref: any
    ) => (
      <Button
        variant="outlined"
        onClick={onClick}
        ref={_ref}
        style={{ fontSize: "13px", boxShadow: theme.shadows[3], border: "none", margin: 0 }}
      >
        {value}
      </Button>
    )
  );
  return (
    <Grid
      style={{
        display: "flex",
      }}
    >
      <IconButton
        size="small"
        onClick={() => {
          onChange(value - 1);
        }}
      >
        <FontAwesomeIcon
          icon={faCaretLeft}
          style={{ color: theme.palette.primary.main }}
        />
      </IconButton>

      <DatePicker
        selected={new Date(value.toString())}
        onChange={(date) => {
          !!date && onChange(date.getFullYear());
        }}
        locale={getCurrentLanguage()}
        customInput={React.createElement(CustomInput)}
        showYearPicker
        dateFormat="yyyy"
      />

      <IconButton
        size={"small"}
        onClick={() => {
          onChange(value + 1);
        }}
      >
        <FontAwesomeIcon
          icon={faCaretRight}
          style={{ color: theme.palette.primary.main }}
        />
      </IconButton>
    </Grid>
  );
};
export default YearPicker;
